import React from "react";
import { IoSunny, IoMoon } from "react-icons/io5";
import { HiComputerDesktop } from "react-icons/hi2";
import useThemeMode from "../../../hooks/useThemeMode";

const modes = [
    { key: "light", icon: IoSunny, label: "Light" },
    { key: "dark", icon: IoMoon, label: "Dark" },
    { key: "system", icon: HiComputerDesktop, label: "System" },
];

/**
 * Theme toggle styled as a wide pill with icon buttons.
 * Active mode gets a raised card-like highlight; dark-mode moon gets an orange accent.
 */
export default function ThemeToggle({ compact = false }) {
    const { theme, setTheme } = useThemeMode();

    return (
        <div className={`px-3 ${compact ? "py-1.5" : "py-2"}`}>
            <div className="flex items-center w-full rounded-lg bg-muted/70 dark:bg-[#1a1d25] p-1 gap-1 border border-border/50">
                {modes.map(({ key, icon: Icon, label }) => {
                    const isActive = theme === key;
                    return (
                        <button
                            key={key}
                            onClick={(e) => {
                                e.stopPropagation();
                                setTheme(key);
                            }}
                            title={label}
                            className={`
                flex-1 flex items-center justify-center h-8 rounded-lg transition-all duration-200 bg-transparent
                ${isActive
                                    ? "bg-background dark:bg-[#2a2d35] shadow-sm ring-1 ring-border/30"
                                    : "hover:bg-background/50 dark:hover:bg-white/5"
                                }
              `}
                        >
                            <Icon
                                className={`w-4 h-4 transition-colors duration-200 ${isActive ? "text-primary" : "text-muted-foreground"
                                    }`}
                            />
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
